import { useContext } from "react";
import { NewRequestContext } from "../context";

export function useNewRequestContext() {
  const { state, dispatch } = useContext(NewRequestContext);
  return { state, dispatch };
}
